import axios from 'axios';
import {
  CAPITAL_CONSENT_URL,
  GET_DASHBOARD_CAPITAL,
  CAPITAL_PREAPPROVALS_URL,
  PUT_SIGIN_CONTRACT_CLICK,
  FINAL_APPROVALS,
  ELIGIBLE_CHECK,
  COMMONWEALTH_PROVINCES,
  COMMONWEALTH_CITIES,
} from './constants';

function commonReject(error) {
  let eobj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else if (data.meta) {
      eobj = new Error(data.meta.error_message.error);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return Promise.reject(eobj);
}

export function getPermissionStatus() {
  return axios.get(CAPITAL_CONSENT_URL, {}).catch(commonReject);
}
export function getDashboardList(payload) {
  const query = (payload && payload.query) || '';
  return axios.get(`${GET_DASHBOARD_CAPITAL}${query}`, {}).catch(commonReject);
}

export function allowPermission() {
  return axios.post(CAPITAL_CONSENT_URL, {}).catch(commonReject);
}

export function postPreApprovals() {
  return axios.post(CAPITAL_PREAPPROVALS_URL, {}).catch(commonReject);
}

export function getPreApprovals() {
  return axios.get(CAPITAL_PREAPPROVALS_URL, {}).catch(commonReject);
}

export function signInContractClick(documentId) {
  return axios.put(PUT_SIGIN_CONTRACT_CLICK(documentId), {}).catch((error) => {
    let eobj;
    if (error.response) {
      const { data } = error.response;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else if (data.meta) {
        const messages: any[] = [];
        for (const key in data.meta.error_message) {
          if (
            Object.prototype.hasOwnProperty.call(data.meta.error_message, key)
          ) {
            messages.push(data.meta.error_message[key]);
          }
        }
        eobj = new Error(messages.join(', '));
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return Promise.reject(eobj);
  });
}

export function postFinalApprovals(data) {
  return axios.post(FINAL_APPROVALS, data, {}).catch((error) => {
    let eobj;
    if (error.response) {
      const { data: resp } = error.response;
      if (resp.errors) {
        eobj = new Error(resp.errors);
      } else if (resp.message) {
        eobj = new Error(resp.message);
      } else if (resp.meta) {
        const messages: any[] = [];
        for (const key in resp.meta.error_message) {
          if (
            Object.prototype.hasOwnProperty.call(resp.meta.error_message, key)
          ) {
            messages.push(resp.meta.error_message[key]);
          }
        }
        eobj = new Error(messages.join(', '));
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return Promise.reject(eobj);
  });
}

export function fastLoanSubmissionCheck() {
  return axios
    .get(`${GET_DASHBOARD_CAPITAL}?lender-category=FAST_LOAN`, {})
    .catch(commonReject);
}

export function fastLoanEligibleCheck() {
  return axios
    .get(`${ELIGIBLE_CHECK}?lender-category=FAST_LOAN`, {})
    .catch(commonReject);
}

export function termLoanEligibleCheck() {
  return axios
    .get(`${ELIGIBLE_CHECK}?lender-category=TERM_LOAN`, {})
    .catch(commonReject);
}

export function investmentSubmissionCheck() {
  return axios
    .get(`${GET_DASHBOARD_CAPITAL}?lender-category=INVESTMENTS`, {})
    .catch(commonReject);
}

export function investmentEligibleCheck() {
  return axios
    .get(`${ELIGIBLE_CHECK}?lender-category=INVESTMENTS`, {})
    .catch(commonReject);
}

export function getProvinces() {
  return axios.get(`${COMMONWEALTH_PROVINCES}`, {}).catch(commonReject);
}

export function getCities() {
  return axios.get(`${COMMONWEALTH_CITIES}`, {}).catch(commonReject);
}
